import Api from './Api';

class TipoProdutoService {
  constructor() {
    this.$api = Api;
  }

  async findAll(filters) {
    return this.$api.get('/tipos-produto', filters);
  }

  async save(data) {
    const id = data.id || 0;

    if (id === 0) {
      return this.$api.post('/tipo-produto', data);
    }

    return this.$api.put(`/tipo-produto/${id}`, data);
  }

  async findById(id) {
    return this.$api.get(`/tipo-produto/${id}`);
  }

  async remove(id) {
    return this.$api.delete(`/tipo-produto/${id}`);
  }
}

export default new TipoProdutoService();
